import React, { useEffect, useRef } from 'react';
import img_1 from '../images/img-1.jpg';
import img_2 from '../images/img-2.jpg';
import img_3 from '../images/img-3.png';
import img_4 from '../images/img-4.jpg';
import blog_man from '../images/blog_man.jpg';
import { Link } from 'react-router-dom';
import Date from 'react-date-object';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function BlogCard() {
  const carouselRef = useRef(null);

  useEffect(() => {
    const carousel = carouselRef.current;
    if (carousel) {
      const bootstrapCarousel = new window.bootstrap.Carousel(carousel);
      bootstrapCarousel.cycle();
    }

    return () => {
      if (carousel) {
        const bootstrapCarousel = window.bootstrap.Carousel.getInstance(carousel);
        bootstrapCarousel.pause();
      }
    };
  }, []);

  var date = new Date();

  const handlePrev = () => {
    const carousel = carouselRef.current;
    if (carousel) {
      const bootstrapCarousel = window.bootstrap.Carousel.getInstance(carousel);
      bootstrapCarousel.prev();
    }
  };

  const handleNext = () => {
    const carousel = carouselRef.current;
    if (carousel) {
      const bootstrapCarousel = window.bootstrap.Carousel.getInstance(carousel);
      bootstrapCarousel.next();
    }
  };


  return (
    <div>
      <div className="container cont-1">
        <div className="row">
          <div id="carouselExample" className="carousel slide col-12 col-lg-6" data-ride="carousel" ref={carouselRef}>
            <div className="carousel-inner">
              <div className="carousel-item active">
                <div className="blog-image-container">
                  <img src={img_1} alt="img" />
                  <div className="blog-text">
                    <h2>What’s In Trend In Womens Fashion Summer?</h2>
                    <p>You can customize the view Blog posts with a simple mouse click and immediately see the result of your changes.</p>
                    <div className="author-info d-flex">
                      <img src={blog_man} alt="img" />
                      <Link className="link" to="#">
                        Marilou Kelleher
                      </Link>
                      <time className="link">{date.format()}</time>
                    </div>
                  </div>
                </div>
              </div>
              <div className="carousel-item">
                <div className="blog-image-container">
                  <img src={img_4} alt="img" />
                  <div className="blog-text">
                    <h2>What’s In Trend In mens Fashion Summer?</h2>
                    <p>You can customize the view Blog posts with a simple mouse click and immediately see the result of your changes.</p>
                    <div className="author-info d-flex">
                      <img src={blog_man} alt="img" />
                      <Link className="link" to="#">
                        Marilou Kelleher
                      </Link>
                      <time className="link">{date.format()}</time>
                    </div>
                  </div>
                </div>
              </div>
              <button className="carousel-control-prev" type="button" onClick={handlePrev}>
              <span className="carousel-control-prev-icon pre-icon" aria-hidden="true"></span>
              {/* <span className="sr-only">Previous</span> */}
            </button>
            <button className="carousel-control-next" type="button" onClick={handleNext}>
              <span className="carousel-control-next-icon next-icon" aria-hidden="true"></span>
              {/* <span className="sr-only ">Next</span> */}
            </button>
            </div>
          </div>


          <div className="col-12 col-lg-6">
            <div className="blog-image-container-2">
              <img src={img_2} alt="img" />
              <div className="blog-text-2">
                <h2>Womens Fashion Summer?</h2>
                <div className='author-info-2 d-flex'>
                  <img src={blog_man} alt="img" />
                  <Link className='link-2' to='#'>Marilou Kelleher</Link>
                  <time className='link-2'>{date.format()}</time>
                </div>
              </div>
            </div>

            <div className="blog-image-container-3">
              <img src={img_3} alt="img" />
              <div className="blog-text-3">
                <h2>Womens Fashion Summer?</h2>
                <div className='author-info-3 d-flex'>
                  <img src={blog_man} alt="img" />
                  <Link className='link-3' to='#'>Marilou Kelleher</Link>
                  <time className='link-3'>{date.format()}</time>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
